import { apiBase, authHeaders } from '../utils/authHeaders';

/**
 * Load ingest source bytes with the session Authorization header.
 * An iframe cannot send Bearer tokens, so we must fetch then blob: URL.
 */
export async function loadIngestSourceBlob(documentId, { orgId, fetchImpl = fetch } = {}) {
  if (!documentId) return { url: null, error: 'No source document' };
  const res = await fetchImpl(`${apiBase()}/api/documents/ingest/${documentId}/view`, {
    headers: authHeaders({ orgId, json: true }),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    let detail = text;
    try {
      const parsed = JSON.parse(text);
      if (parsed && parsed.detail) detail = String(parsed.detail);
    } catch {
      /* keep text */
    }
    return { url: null, error: detail || `Source unavailable (${res.status})` };
  }
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  return { url, error: null, contentType: blob.type || res.headers.get('content-type') || '' };
}
